import { appConfig } from '../../../../config'
import {
  HealthPlanCardResponse,
  CarePlanFormatted,
  HealthPlanSummary,
  HealthPlanOutcomeResponse,
  CheckListResponse,
} from './types'

type HealthPlanReadParams = { accessToken: string; isHealthProgramEnabled: boolean }

const healthPlanReadUrl = (isHealthProgramEnabled: boolean, path: string) =>
  `${appConfig.serverRootUrl}/api/private/${isHealthProgramEnabled ? 'healthProgram' : 'healthPlanV2'}/${path}`

export const getHealthPlanSummary = async ({
  accessToken,
  isHealthProgramEnabled,
}: HealthPlanReadParams): Promise<HealthPlanSummary> => {
  const res = await fetch(healthPlanReadUrl(isHealthProgramEnabled, 'summary'), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || 'Failed to fetch health plan summary')
  }
  return data
}

export const getUserHealthPlanOutcomes = async ({
  accessToken,
  isHealthProgramEnabled,
}: HealthPlanReadParams): Promise<HealthPlanOutcomeResponse> => {
  const res = await fetch(healthPlanReadUrl(isHealthProgramEnabled, 'healthPlanOutcomes'), {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || 'Failed to fetch health plan outcomes')
  }

  return data
}

export const getHealthPlanCards = async ({
  accessToken,
  isHealthProgramEnabled,
}: HealthPlanReadParams): Promise<HealthPlanCardResponse[]> => {
  const res = await fetch(healthPlanReadUrl(isHealthProgramEnabled, 'healthCards'), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const data: HealthPlanCardResponse[] = await res.json()

  if (!res.ok) {
    throw new Error('Failed to fetch health plan cards')
  }

  return data
}

export const getCarePlan = async ({
  accessToken,
  isHealthProgramEnabled,
}: HealthPlanReadParams): Promise<CarePlanFormatted> => {
  const res = await fetch(healthPlanReadUrl(isHealthProgramEnabled, 'carePlan'), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const data: CarePlanFormatted = await res.json()

  if (!res.ok) {
    throw new Error('Failed to fetch care plan')
  }

  return data
}

export const getCheckList = async ({ accessToken }: { accessToken: string }): Promise<CheckListResponse> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthPlanV2/checkList`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const data: CheckListResponse = await res.json()

  if (!res.ok) {
    throw new Error('Failed to fetch checklist')
  }

  return data
}

export const patchCheckListItem = async ({ accessToken, priority }: { accessToken: string; priority: number }) => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthPlanV2/checkList`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ priority }),
  })
  const data = await res.json()
  if (!res.ok) {
    throw new Error(data?.message || 'Unknown error')
  }

  return data
}
